import { jsx as _jsx } from "react/jsx-runtime";
import Script from "next/script.js";
import useFacebookPixel from "./useFacebookPixel.js";
export default function FacebookPixel({ pixelId }) {
    useFacebookPixel();
    let pxId;
    if (Array.isArray(pixelId)) {
        pxId = pixelId.reduce((pxString, currPxId) => {
            pxString += `fbq('init', '${currPxId}');`;
            return pxString;
        }, "");
    }
    else {
        pxId = `fbq('init', '${pixelId}');`;
    }
    return (_jsx(Script, { id: "fb-pixel", strategy: "afterInteractive", dangerouslySetInnerHTML: {
            __html: `
				!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window, document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
            	${pxId}
				fbq('track', 'PageView');
          `,
        } }));
}
